"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCashAdvanceRateEvaluator = exports.checkCashAdvanceRateConfigErrors = exports.sanitizeCashResponseTapeReceivable = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const sanitizeCashResponseTapeReceivable = (sanitizeParams) => {
    const { receivable, requiredFields } = sanitizeParams;
    return lodash_1.default.pick(receivable, requiredFields);
};
exports.sanitizeCashResponseTapeReceivable = sanitizeCashResponseTapeReceivable;
/**
 *Cash advance rate formulas can use variables from CreditAgreement.Config.CashAdvanceRate.AvailableFormulaFields.
 */
const checkCashAdvanceRateConfigErrors = ({ cashAdvanceRateConfig, }) => {
    const { type, config: { engineVersion, formula }, } = cashAdvanceRateConfig;
    (0, common_1.finleyAssert)(type === 'formula', `unknown cashAdvanceRateConfig.type:[${cashAdvanceRateConfig.type}]`);
    const errors = [];
    const { errorMessages } = (0, formula_engine_1.getFormulaErrors)(cashAdvanceRateConfig.config.formula, undefined, formula_engine_1.fullValidFunctions);
    errors.push(...errorMessages);
    // Validate variables by engine version
    const { nonRangeVariables, rangeVariables } = (0, formula_engine_1.getFormulaComposition)(formula);
    switch (engineVersion) {
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.ExcelEngine1: {
            // Only range variables
            if (nonRangeVariables.length) {
                errors.push(`Cash advance rate formula does not support row level variables for portfolio evaluation. Consider using range variables instead. Found row variables: [${nonRangeVariables.join(', ')}]`);
            }
            break;
        }
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1: {
            if (nonRangeVariables.length || rangeVariables.length) {
                errors.push(`Cash advance rate formula does not support variables for portfolio evaluation. Consider using range variables with ExcelEngine instead. Found variables: [${[
                    ...nonRangeVariables,
                    ...rangeVariables,
                ].join(', ')}]`);
            }
            break;
        }
        default:
            return (0, common_1.finleyAssertUnreachable)(engineVersion);
    }
    return { errors, nonRangeVariables, rangeVariables };
};
exports.checkCashAdvanceRateConfigErrors = checkCashAdvanceRateConfigErrors;
const excelEngineEvaluator = ({ formula, requiredFields, f1EngineMode, }) => {
    let excelEngine = null;
    const initializeEngine = (initializeParams) => {
        const { sanitizedReceivables } = initializeParams;
        excelEngine = (0, formula_engine_1.initializeExcelEngine)({
            data: sanitizedReceivables,
            formulas: [formula],
            f1EngineMode,
        });
    };
    const tearDownEngine = () => {
        if (excelEngine) {
            excelEngine.clearSheet();
        }
    };
    const evaluateConfig = () => {
        (0, common_1.finleyAssert)(excelEngine, 'Attachment Rate Limit ExcelEngine is not set. Make sure to initialize first before evaluating');
        const cashAdvanceRate = excelEngine.evaluateNumber(formula);
        return cashAdvanceRate;
    };
    return {
        requiredFields,
        initializeEngine,
        tearDownEngine,
        evaluateConfig,
    };
};
const hyperEngineEvaluator = ({ formula, requiredFields, f1EngineMode, }) => {
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [formula], f1EngineMode);
    // No row variables are allowed at this time
    // Range variables will only be handled by excel engine
    return {
        requiredFields,
        initializeEngine: () => { },
        evaluateConfig: () => formulaEngine.evaluateNumber(formula),
        tearDownEngine: () => { },
    };
};
const createCashAdvanceRateEvaluator = (cashAdvanceRateConfig, f1EngineMode) => {
    (0, common_1.finleyAssert)(cashAdvanceRateConfig.type === 'formula', `Expected cash advance rate config type [${cashAdvanceRateConfig.type}] to be formula`);
    // Validation method will verify that no row level variables are present, otherwise will contain error message in errors array
    const { errors, rangeVariables } = (0, exports.checkCashAdvanceRateConfigErrors)({
        cashAdvanceRateConfig,
    });
    (0, common_1.finleyAssert)(errors.length === 0, `Found errors during cash advance rate evaluation: ${errors.join(' ')}`);
    const requiredFields = rangeVariables.map((rangeVariable) => (0, formula_engine_1.extractVariableNameFromRange)(rangeVariable));
    const { engineVersion, formula } = cashAdvanceRateConfig.config;
    switch (engineVersion) {
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.ExcelEngine1:
            return excelEngineEvaluator({ formula, requiredFields, f1EngineMode });
        case finley_types_1.FormulaEngine.FullSupportedFormulaEngines.HyperFormula1:
            return hyperEngineEvaluator({
                formula,
                requiredFields: [],
                f1EngineMode,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(engineVersion);
    }
};
exports.createCashAdvanceRateEvaluator = createCashAdvanceRateEvaluator;
//# sourceMappingURL=cashAdvanceRateEvaluator.js.map